import React, { useState } from 'react';
import { withErrorBoundary } from '@nile/components';
import SectionHeader from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionHeader';
import AggregationTable from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionAdditionalData/AggregationTable';

const CustomDataTable = ({
  advancedChart,
  condition,
  client = null,
  setClient,
  dynamicRowCount = false,
  customReport = false
}) => {
  const { name, description, columns, filter, api } = advancedChart || {};

  const [value, setValue] = useState(filter?.value || {});

  const getFilterCondition = () => {
    switch (api) {
      case 'getClientEfficiencyRanking':
        return {
          condition: {
            type: value
          },
          hasPagination: true,
          nested: true
        };
      case 'getClientSpecificEfficiency':
        return {
          condition: {
            client: {
              accountId: `${client}`
            }
          },
          hasPagination: false
        };
      case 'getContractFinancialPerformanceMetrics':
      case 'getClientFinancialPerformanceMetrics':
      case 'getServiceUtilisation':
      case 'getTechnicianUtilisation':
        return {
          hasPagination: true,
          nested: false
        };
      default:
        return {};
    }
  };

  const filterCondition = getFilterCondition();

  return (
    <div className="flex g10 fcol full-height">
      <SectionHeader
        size="h3"
        hideIcon
        name={name}
        description={description}
        action={{ ...filter, value, setValue }}
      />
      <AggregationTable
        columns={columns}
        name={name}
        api={api}
        advancedChart={advancedChart}
        setClient={setClient}
        condition={{
          defaultCondition: condition,
          filterCondition: filterCondition?.condition,
          hasPagination: filterCondition?.hasPagination,
          nested: filterCondition?.nested
        }}
        clientData={client}
        dynamicRowCount={dynamicRowCount}
        customReport={customReport}
        padded="lg"
        showAI={
          name ===
          'reports.efficiencyReport.client_resource_efficiency.efficiencyBy.ticket.category.name'
        }
      />
    </div>
  );
};

export default withErrorBoundary(CustomDataTable);
